import { useContext } from 'react';

import BaseUrlContext from '@app/helpers/BaseUrl';

const useBaseUrl = (): string => useContext(BaseUrlContext);

export default useBaseUrl;
